import{useContext}from'react';import{SSOContext}from'../../models/SSOProvider';function useSSO(){return useContext(SSOContext);}export default useSSO;
//# sourceMappingURL=useSSO.js.map